/**
 * Leaves the SPA for another origin, such as Google's sign-in page. The one place the app hands
 * the tab to a URL the router does not own; tests mock this module.
 */
export function leaveFor(url: string): void {
  window.location.assign(url);
}
